import React, { useEffect, useState } from 'react';
import { Mail, X } from 'lucide-react';

/* Soft, non-blocking ask: VIP guests walk in without friction, but ~35s in
   Rachel offers to save their access — real email (+optional phone) → DB → CRM → Event Bus. */
export function VipIdentityCard({ isEs }) {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [done, setDone] = useState(false);
  const API = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    if (sessionStorage.getItem('kx_vip_prompt_done')) return undefined;
    let t;
    fetch(`${API}/api/demo-access/vip-session`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { if (j?.vip && !j.identified) t = setTimeout(() => setShow(true), 35000); })
      .catch(() => {});
    return () => clearTimeout(t);
  }, [API]);

  const dismiss = () => { setShow(false); try { sessionStorage.setItem('kx_vip_prompt_done', '1'); } catch { /* noop */ } };
  const submit = async () => {
    const em = email.trim().toLowerCase();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)) { setErr(isEs ? 'Revisa tu email' : 'Check your email'); return; }
    setBusy(true); setErr('');
    try {
      const r = await fetch(`${API}/api/demo-access/vip-identify`, {
        method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: em, phone: phone.trim() }) });
      if (!r.ok) throw new Error();
      setDone(true);
      setTimeout(dismiss, 3500);
    } catch { setErr(isEs ? 'No se pudo guardar — inténtalo de nuevo' : "Couldn't save — try again"); }
    finally { setBusy(false); }
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-4 right-4 z-[70] w-[330px] max-w-[calc(100vw-2rem)] rounded-2xl bg-white shadow-2xl border border-gray-200 p-4 animate-in" data-testid="vip-identity-card">
      <div className="flex items-start gap-2.5">
        <img src="/avatars/rachel.png" alt="Rachel" className="w-9 h-9 rounded-full object-cover shrink-0" />
        <div className="min-w-0 flex-1">
          {done ? (
            <p className="text-[13px] font-semibold text-emerald-600" data-testid="vip-identity-done">
              ✓ {isEs ? 'Guardado — tu acceso VIP ya es tuyo para siempre.' : 'Saved — your VIP access is yours for good.'}
            </p>
          ) : (
            <>
              <p className="text-[13px] font-bold text-gray-900">{isEs ? '¿Te guardo tu acceso VIP?' : 'Shall I save your VIP access?'}</p>
              <p className="mt-0.5 text-[11.5px] text-gray-500 leading-snug">
                {isEs ? 'Déjame tu email y vuelves cuando quieras — sin registro.' : 'Leave me your email and come back anytime — no signup.'}
              </p>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && submit()} placeholder={isEs ? 'tu@email.com' : 'you@email.com'}
                data-testid="vip-identity-email"
                className="mt-2 w-full h-9 rounded-full border border-gray-200 px-3.5 text-[12.5px] outline-none focus:border-[var(--rest-accent,#F77F11)] transition-colors" />
              <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)}
                placeholder={isEs ? 'teléfono (opcional)' : 'phone (optional)'} data-testid="vip-identity-phone"
                className="mt-1.5 w-full h-9 rounded-full border border-gray-200 px-3.5 text-[12.5px] outline-none focus:border-[var(--rest-accent,#F77F11)] transition-colors" />
              {err && <p className="mt-1.5 text-[11px] text-red-500" data-testid="vip-identity-error">{err}</p>}
              <button onClick={submit} disabled={busy} data-testid="vip-identity-submit"
                className="mt-2 w-full h-9 rounded-full bg-[var(--rest-accent,#F77F11)] text-white text-[12.5px] font-bold flex items-center justify-center gap-1.5 hover:brightness-110 transition-all disabled:opacity-50">
                <Mail className="w-3.5 h-3.5" /> {busy ? '…' : (isEs ? 'Guardar mi acceso' : 'Save my access')}
              </button>
            </>
          )}
        </div>
        <button onClick={dismiss} aria-label={isEs ? 'Cerrar' : 'Close'} data-testid="vip-identity-dismiss"
          className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-gray-300 hover:text-gray-700 hover:bg-gray-100 transition-colors">
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
